module.exports = __webpack_public_path__ + "assets/add.4cd98d345809ff5d116a6fe6ba38e9b3.png";